<template>
  <div class="header">
    <v-navigation-drawer
      v-model="drawer"
      app
      right
      width="70%"
      height="100vh"
      class="sidebar show-res"
      hide-overlay
    >
      <div
        @click="toggleSidebar()"
        class="drawer-hide ms-5"
        width="25"
        height="63"
        contain
        v-if="drawer"
      >
        <v-icon>mdi-close</v-icon>
      </div>
      <div class="sidebar__avatar-wrapper" dir="rtl">
        <v-row class="align-center justify-center">
          <v-col cols="5" class="d-flex align-center justify-center">
            <img :src="config.logoAddress" width="80%" alt="logo of company" />
          </v-col>
          <v-col cols="7" class="d-flex align-center justify-start">
            <h1 class="text-p-dark">{{ config.title }}</h1>
          </v-col>
        </v-row>
      </div>

      <v-list
        dir="rtl"
        class="sidebar-items"
        density="compact"
        nav
        v-for="mMenu in menus.filter((menus) => menus.name === 'Main')"
        :key="mMenu.id"
      >
        <v-list-item
          v-for="(item, index) in mMenu.children"
          :key="index"
          :to="item.link"
          link
        >
          <v-list-item-content>
            <v-list-item-title
              v-if="item.isActive"
              class="d-flex align-center justify-space-between"
            >
              <v-icon class="me-2 icon-sidebar">mdi-circle</v-icon>
              <span
                class="text-start text-p-dark p-fw-bold"
                style="width: 283px"
              >
                {{ item.text }}
              </span>
              <div class="arrow-circle">
                <v-icon class="p-fs-xl">mdi-chevron-left</v-icon>
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-row v-if="!token">
        <v-col cols="12" class="d-flex justify-center mt-2">
          <v-btn
            color="first"
            height="45px"
            width="90%"
            class="intro-btn p-fs-m radius-p-l text-p-white"
            small
            depressed
            @click="goToLogin"
          >
            ورود/ ثبت نام
          </v-btn>
        </v-col>
      </v-row>
      <v-divider
        class="mt-10"
        style="border-color: #f76465; opacity: 0.2"
      ></v-divider>
      <v-row dir="rtl" class="mt-5" v-if="config.address">
        <v-col cols="12" class="d-flex align-center">
          <v-icon class="me-1">mdi-map-marker-outline</v-icon>
          <h5 class="text-p-muted mt-2">{{ config.address }}</h5>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="d-flex align-center pt-0" v-if="config.tel">
          <v-icon class="me-1">mdi-phone-outline</v-icon>
          <h4 class="text-p-muted mt-2">{{ config.tel }}</h4>
        </v-col>
        <v-col cols="12" class="d-flex align-center pt-0" v-if="config.email">
          <v-icon class="me-1">mdi-email-outline</v-icon>
          <h4 class="text-p-muted mt-2">{{ config.email }}</h4>
          <h3></h3>
        </v-col>
      </v-row>
      <v-row class="mt-3">
        <v-col cols="12" class="d-flex justify-center share-icon">
          <a
            v-for="item in socials.filter(
              (z) => z.isActive && z.link.length > 1
            )"
            :key="item.id"
            class="pa-1 rounded-circle ml-1 icon-btn"
            :href="item.link"
          >
            <v-img
              :src="item.iconAddress"
              contain
              alt="icon of social network"
            />
          </a>
        </v-col>
      </v-row>
    </v-navigation-drawer>

    <v-navigation-drawer
      v-model="cartDrawer"
      app
      temporary
      right
      width="22%"
      class="cartDrawer"
    >
      <v-list-item>
        <v-icon class="ml-2" size="15pt"> mdi-cart-variant </v-icon>
        سبد خرید شما
      </v-list-item>

      <v-divider></v-divider>

      <v-list nav v-if="token && token.length > 5">
        <v-list-item v-for="item in factorDetail.details" :key="item.id">
          <v-row class="cart-cards align-center">
            <v-col cols="3">
              <img :src="item.productImage" width="60" alt="productImage" />
            </v-col>
            <v-col cols="9">
              <p class="p-fw-semibold mb-3">{{ item.productTitle }}</p>
              <p class="p-fs-n mb-2">برند {{ item.productBrand }}</p>
              <p class="p-fs-s mb-0">
                {{ item.count }} عدد |
                <span class="text-p-first-light"
                  >{{ item.productPrice | localNum }}
                  {{ label.caption.currencyType }}
                </span>
              </p>
            </v-col>
          </v-row>
        </v-list-item>
        <v-list-item
          class="d-flex justify-center mt-5"
          v-if="factorDetail.details && factorDetail.details.length > 0"
        >
          <v-btn class="bg-p-success w-100 text-p-white" @click="cartPage">
            <v-icon small class="ml-1">
              mdi-checkbox-marked-circle-outline
            </v-icon>
            ثبت سفارش و ارسال
          </v-btn>
        </v-list-item>
        <v-list-item class="d-flex justify-center mt-5" v-else>
          <p class="p-fs-n p-fw-semibold p-lh-n text-p-first">
            سبد خرید شما خالی می باشد.
          </p>
        </v-list-item>
      </v-list>
      <div class="pa-2" v-else>
        <p class="p-fs-n p-fw-semibold p-lh-n text-p-first">
          برای ثبت سفارش و استفاده از تمام امکانات فروشگاه، وارد حساب کاربری خود
          شوید و یا ثبت نام کنید.
        </p>
        <v-btn class="bg-p-success w-100 text-p-white" :to="{ name: 'Login' }">
          <v-icon small class="ml-1"> mdi-login-variant </v-icon>ورود/ ثبت نام
        </v-btn>
      </div>
    </v-navigation-drawer>

    <!-- Desktop Menu -->
    <!-- <div
      class="header__top hide-res align-center"
      v-if="
      config.email ||
        config.address ||
        (socials.length > 0 &&
          socials.filter((z) => z.isActive && z.link.length > 1))
      "
    >
      <v-container>
        <v-row class="align-center">
          <v-col cols="5" sm="3" class="item-socials pt-5 ps-10 hide-res">
            <a
              v-for="item in socials.filter(
                (z) => z.isActive && z.link.length > 1
              )"
              :key="item.id"
              class="pa-1 rounded-circle ml-1 icon-btn bg-p-disabled"
              :href="item.link"
            >
              <v-img
                :src="item.iconAddress"
                contain
                alt="icon of social network"
              />
            </a>
          </v-col>
          <v-col
            cols="4"
            lg="3"
            class="d-flex align-center"
            v-if="config.email"
          >
            <v-icon class="me-2 text-p-first">mdi-email</v-icon>
            <h4 class="p-fw-semibold">{{ config.email }}</h4>
          </v-col>
          <v-col
            cols="8"
            lg="4"
            class="item-address d-flex align-center"
            v-if="config.address"
          >
            <v-icon class="me-2 text-p-first">mdi-map-marker-radius</v-icon>
            <h5 class="p-fw-semibold">
              {{ config.address }}
            </h5>
          </v-col>
        </v-row>
      </v-container>
    </div> -->

    <div class="header__upper py-0">
      <v-container class="md-py-0 md-px-0">
        <v-row>
          <v-col
            cols="6"
            lg="3"
            md="3"
            sm="4"
            class="d-flex justify-center align-center"
          >
            <router-link
              :to="{ name: 'Home' }"
              class="d-flex justify-center align-center"
            >
              <img
                v-if="config.logoAddress"
                :src="config.logoAddress"
                width="20%"
                alt="logo of company"
              />
              <h1 class="ms-2 text-p-dark" v-if="config.title">
                {{ config.title }}
              </h1>
            </router-link>
          </v-col>
          <v-col cols="7" lg="7" md="6" sm="5" class="hide-res">
            <v-autocomplete
              v-model="search"
              :items="products"
              auto-select-first
              class="flex-full-width"
              density="comfortable"
              item-props
              placeholder="جستجو"
              color="first"
              prepend-inner-icon="mdi-magnify"
              theme="light"
              variant="outlined"
              rounded
              @input="openProductDetails"
              clearable
            >
              <template v-slot:append>
                <v-icon color="first" class="arrow-icon">
                  mdi-chevron-down
                </v-icon>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="6" lg="2" md="3" sm="3" class="login-header">
            <div
              class="text-p-dark d-flex p-relative"
              @click.stop="cartDrawer = !cartDrawer"
            >
              <span class="icon-cart p-fs-huge p-pointer"></span>
              <span class="count" v-if="factorDetail && factorDetail.details">
                {{ factorDetail.details.length }}
              </span>
              <span class="count" v-else> 0 </span>
            </div>
            <router-link v-if="token" :to="{ name: 'PanelDashboard' }">
              <v-icon class="ms-2 text-p-dark p-fs-huge">
                mdi-account-outline
              </v-icon>
              <span class="text-p-first-light">{{ profile.fullName }}</span>
            </router-link>
            <router-link
              v-else
              :to="{ name: 'Login' }"
              class="text-p-dark d-flex p-relative mr-2"
            >
              <span>ورود/ ثبت نام</span>
            </router-link>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-app-bar flat color="#1e2843" class="header__menu">
      <v-row class="align-center">
        <v-col cols="2" class="show-res text-center">
          <div @click="toggleSidebar()" elevation="0" fab v-if="!drawer">
            <i class="fas fa-bars p-fs-xxxl text-p-white"></i>
          </div>
        </v-col>
        <v-col cols="1"></v-col>
        <v-col cols="9" class="header__upper show-res">
          <v-autocomplete
            v-model="search"
            :items="products"
            auto-select-first
            class="flex-full-width custom-placeholder"
            density="comfortable"
            hide-details
            item-props
            placeholder="جستجو"
            theme="light"
            variant="outlined"
            rounded
            @input="openProductDetails"
            clearable
          >
            <template v-slot:append>
              <v-icon color="first" class="arrow-icon">
                mdi-chevron-down
              </v-icon>
            </template>
            <template v-slot:prepend-inner>
              <v-icon class="text-p-white search-icon-header">
                mdi-magnify
              </v-icon>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="align-center hide-res">
        <v-col cols="6">
          <div
            class="d-flex align-center text-center text-p-white"
            v-for="topMenu in menus.filter((menus) => menus.name === 'Main')"
            :key="topMenu.id"
          >
            <div
              v-for="menu in topMenu.children.filter(
                (topMenu) => topMenu.children === null
              )"
              :key="menu.id"
            >
              <v-btn text v-if="menu.isActive" @click="routeLink(menu)">
                {{ menu.text }}
              </v-btn>
            </div>
          </div>
        </v-col>
        <v-col cols="1"></v-col>
        <v-col cols="5">
          <div class="menu-phone hide-res" v-if="config.tel">
            <div class="circle-phone me-2">
              <v-icon class="text-p-first">mdi-phone</v-icon>
            </div>
            <h4 class="text-p-white p-fw-semibold">{{ config.tel }}</h4>
          </div>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";

export default {
  name: "TheHeader",
  computed: {
    ...mapGetters({
      profile: "panelX/profile",
      menus: "baseX/menus",
      config: "baseX/config",
      factorDetail: "panelX/factorDetail",
      products: "clientX/productsOptions",
      socials: "clientX/socials",
    }),
    routeName() {
      return this.$route.name;
    },
  },
  data() {
    return {
      alert,
      label,
      drawer: null,
      cartDrawer: null,
      search: " ",
      token: localStorage.getItem("panelToken"),
    };
  },
  watch: {
    config() {
      const faviconLink = document.querySelector("link[rel='icon']");
      faviconLink.href = this.config.faviconAddress;
    },
  },
  methods: {
    toggleSidebar() {
      this.drawer = !this.drawer;
    },
    toggleCart() {
      this.cartDrawer = !this.cartDrawer;
    },
    logout() {
      this.$store.dispatch("panelX/logout");
    },
    goToLogin() {
      this.$router.push({ name: "Login" });
    },
    setStaticLink(item) {
      if (item.startsWith("/", 0)) {
        return item;
      } else {
        return "/" + item;
      }
    },
    routeLink(menu) {
      if (menu.link.indexOf("https") === 0 || menu.link.indexOf("http") === 0) {
        window.open(menu.link, "_blank");
      } else {
        this.$router.push(this.setStaticLink(menu.link)).catch(() => {});
      }
    },
    cartPage() {
      this.$router.push({ name: "UserCart" });
    },
    openProductDetails(itemId) {
      this.$router.push({
        name: "ProductDetails",
        params: { id: itemId },
      });
    },
  },
  mounted() {
    if (this.token && this.token.length > 5) {
      this.$store.dispatch("panelX/getFactorDetail");
      this.$store.dispatch("panelX/getProfile");
    }
  },
  beforeCreate() {
    this.$store.dispatch("baseX/getMenus");
    this.$store.dispatch("baseX/getConfig");
    let payload = "pageSize=100000&pageNumber=1&sort=1";
    this.$store.dispatch("clientX/getProducts", payload);
    this.$store.dispatch("clientX/getSocials");
  },
};
</script>
